import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import './Blog.scss';

import BlogPostCard from '../Main/blog/BlogPostCard';

const Blog = props => {
  const { blogPageContent, blogPosts } = props;

  const hreflang = blogPageContent.node.node_locale === 'fr' ? 'en' : 'fr';

  return (
    <div className="blog">
      <Helmet>
        <html lang={blogPageContent.node.node_locale} />
        <title>{blogPageContent.node.title}</title>
        <meta name="description" content={blogPageContent.node.description} />
        <link
          rel="alternate"
          hreflang={hreflang}
          href={`https://www.offshoreservices.fr/${hreflang}/blog/`}
        />
      </Helmet>
      <div className="container">
        <div className="blog-title">
          <h1>BLOG</h1>
          <h2>{blogPageContent.node.subTitle}</h2>
          <div className="blog-posts">
            {blogPosts &&
              blogPosts.map((blogPost, i) => {
                return (
                  <BlogPostCard
                    key={i}
                    blogPost={blogPost}
                    timeToRead={blogPageContent.node.timeToRead}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

Blog.propTypes = {
  blogPageContent: PropTypes.object,
  blogPosts: PropTypes.array,
};

export default Blog;



// WEBPACK FOOTER //
// ./src/components/Pages/Blog.js